<script>
import Cookies from "js-cookie";
import {notificationMethods, siteMethods, uploadMethods} from "@/state/helpers";
import {required} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sites",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      currentUser: JSON.parse(Cookies.get('user')),
      sites: [],
      title: "Siteler Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Siteler",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal: false,
      formError: '',
      editFormError: '',
      addForm: {
        name: null,
        domain: null,
        smsFrom: null,
        logo: null,
        field: null,
      },
      editForm: {
        name: null,
        domain: null,
        smsFrom: null,
        logo: null,
        field: null,
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: 'Site Adı',
          sortable: true,
        },
        {
          key: "domain",
          sortable: true,
        }, {
          key: "field",
          label: 'Saha Durumu',
          sortable: true,
        },

        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput: 1
    };
  },
  validations: {
    addForm: {
      name: {required},
      domain: {required},
      smsFrom: {required},
      logo: {required},
    },
    editForm: {
      name: {required},
      domain: {required},
      smsFrom: {required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch: {
    page(newPage) {
      this.pageInput = newPage;
      this.getSites(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getSites();
        } else {
          this.page = 1;
        }
      }
    },
    'addForm.email': function () {
      this.addForm.email = this.turkishToLower(this.addForm.email)
    },
    'editForm.email': function () {
      this.editForm.email = this.turkishToLower(this.editForm.email)
    }
  },
  mounted() {
    this.getSites();
  },
  methods: {
    ...siteMethods,
    ...notificationMethods,
    ...uploadMethods,
    updateImageUrl(url) {
      this.imageUrl = url;
    },
    onImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'site-logo')
      let addForm = this.addForm;
      this.imgLoading = true;
      this.uploadFile(data).then((res) => {
        addForm.logo = res.url;
        this.imgLoading = false;
      })
    },
    onEditImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length) return;

      let data = new FormData();
      data.append("upload", files[0]);
      data.append("folder", "site-logo");
      let editForm = this.editForm;
      this.editImgLoading = true;
      this.uploadFile(data)
          .then((res) => {
            editForm.logo = res.url;
            this.imageUrl = res.url;
            this.editImgLoading = false;
          });
      this.$v.editForm.image.$touch();
    },

    resetForm() {
      this.addForm = {
        name: null,
        logo: null,
        domain: null,
        smsFrom: null,
        field: null,
      }; this.editForm = {
        name: null,
        logo: null,
        domain: null,
        smsFrom: null,
        field: null,
      };
      this.addSubmitted=false,
          this.editSubmitted=false
    },
    doSearch() {
      if (this.page === 1) {
        this.getSites();
      } else {
        this.page = 1;
      }
    },
    getSites(page = this.page) {
      this.itemsLoaded = false;
      let filter = {}
      if (this.filter) {
        filter.name = this.filter;
      }
      this.fetchSites({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;
        // getting category ready for fields
        this.items = res.docs.map(elem => {
          return elem;
        })
        this.itemsLoaded = true;
      })
    },

    handleSubmit() {
      this.addSubmitted = true;
      this.formError = "";
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {
        const field = this.addForm.field ? "true" : "false";
        this.createSite({
          ...this.addForm,
          field, // Checkbox alanı
        }).then(() => {
          this.toastMessage = "Site başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.showModal = false;
          this.getSites();
          this.addForm.name = "";
          this.addForm.domain = "";
          this.addForm.smsFrom = "";
          // this.addForm.code = "";
        }).catch((err) => {
          if (err == 'TCNUMBER_ALREADY_USE') {
            this.formError = "Girilen TC numarasına sahip bir Site bulunmaktadır."
          } else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleEditSubmit() {
      this.editSubmitted = true;
      this.editFormError = ""
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {
        const field = this.editForm.field ? "true" : "false";
        this.updateSite({
          id: this.editId,
          data: {
            ...this.editForm,
            field,
          },
        }).then(() => {
          this.toastMessage = "Site başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.editModal = false;
          this.getSites();
          this.addForm.name = "";
          this.addForm.domain = "";
          this.addForm.smsFrom = "";
        }).catch((err) => {
          if (err == 'TCNUMBER_ALREADY_USE') {
            this.editFormError = "Girilen TC numarasına sahip bir Site bulunmaktadır."
          } else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleDeleteSubmit() {
      this.deleteSite(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Site başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getSites();
      })
    },
    openEdit(site) {
      this.editForm.name = site.name
      this.editForm.domain = site.domain
      this.editForm.smsFrom = site.smsFrom
      this.editForm.logo = site.logo
      // this.editForm.code = site.code
      this.editForm.field = site.field;
      this.editId = site.id;
      this.editModal = true;
      this.updateImageUrl(site.logo);

    },
    openDelete(site) {
      if (site.email === this.currentUser.email) {
        this.noDeleteModal = true;
      } else {
        this.deleteId = site.id;
        this.deleteModal = true;
      }
    },
    turkishToLower(str) {
      let letters = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
      str = str.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) {
        return letters[letter];
      })
      return str.toLowerCase();
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="resetForm(); showModal = true"
                >
                  Site Ekle
                </button>
              </div>
            </div>
            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:cell(createdAt)="data">
                    {{ new Date(data.item.createdAt).toDateString() }}
                  </template>
                  <template v-slot:cell(field)="data">
                 <span class="badge badge-pill font-size-14"
                       :class="{ 'badge-soft-success': data.item.field, 'badge-soft-danger': !data.item.field }">
                    <span>{{ data.item.field ? 'Aktif' : 'Pasif' }}</span>
                  </span>
                  </template>
                  <template v-slot:cell(detail)="data">
                    <button
                        class="btn btn-info d-flex py-2"
                        @click="$router.push({name:'siteDetail',params:{siteId: data.item.id}})"
                    >
                      <i :class="`bx bxs-detail bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input
                        :style="{width:'30px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}"
                        @keyup.enter="page=pageInput" v-model="pageInput" type="text" class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="md" v-model="showModal" title="Site Ekle" hide-footer @hide="resetForm">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Site Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Site adı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Site Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="domain">Domain</label>
                <input
                    id="domain"
                    type="text"
                    v-model="addForm.domain"
                    class="form-control"
                    placeholder="Domain adresi giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.domain.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.domain.required"
                    class="invalid-feedback"
                >
                  Domain adresi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="domain">SMS Başlığı</label>
                <input
                    id="smsFrom"
                    type="text"
                    v-model="addForm.smsFrom"
                    class="form-control"
                    placeholder="SMS Başlığı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.smsFrom.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.smsFrom.required"
                    class="invalid-feedback"
                >
                  SMS Başlığı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>

            <div class="col-12 mt-1">
              <div class="mb-3">
                <label for="image" class="form-label">Logo</label>

                <input
                    type="file"
                    id="logo"
                    @change="onImageChange"
                    accept="image/*"
                    class="form-control"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.logo.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.logo.required"
                    class="invalid-feedback"
                >
                  Logo girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="field" class="me-2">Saha</label>
                <input
                    id="field"
                    type="checkbox"
                    v-model="addForm.field"
                    class="form-check-input"
                />
              </div>
            </div>
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();">Vazgeç</b-button>
            <b-button type="submit" variant="success" class="ms-1">Site Ekle</b-button>
          </div>
        </form>
      </b-modal>
      <b-modal size="md" v-model="editModal" title="Site Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    :disabled="currentUser.role.includes('user')"
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="domain">Domain</label>
                <input
                    :disabled="currentUser.role.includes('user')"
                    id="domain"
                    type="text"
                    v-model="editForm.domain"
                    class="form-control"
                    placeholder="Domain adresi giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.domain.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.domain.required"
                    class="invalid-feedback"
                >
                  Domain adresi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="domain">SMS Başlığı</label>
                <input
                    :disabled="currentUser.role.includes('user')"
                    id="smsFrom"
                    type="text"
                    v-model="editForm.smsFrom"
                    class="form-control"
                    placeholder="SMS Başlığı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.smsFrom.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.smsFrom.required"
                    class="invalid-feedback"
                >
                  SMS Başlığı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="image" class="form-label">Logo</label>
                <input
                    type="file"
                    id="logo"
                    @change="onEditImageChange"
                    accept="image/*"
                    class="form-control"
                />

                <div v-if="editForm.logo" class="mt-2 text-center">
                  <img :src="editForm.logo" alt="Mevcut Logo" style="max-width: 50%; max-height: 100px;"/>
                </div>
              </div>


            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="field" class="me-2">Saha</label>
                <input
                    id="field"
                    type="checkbox"
                    v-model="editForm.field"
                    class="form-check-input"
                />
              </div>
            </div>
            <div
                v-if="editFormError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ editFormError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Site Düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu Siteyi silmek istediğinize emin misiniz? Silinmiş Siteyi geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız Siteyi silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.pill span {
  padding: 6px 12px 4px 12px;
}

</style>
